import { useState } from "react";
import {
    Divider,
    RadioButton,
    TextField,
    Tooltip,
    Typography,
} from "@volvo/vcdk-react";
import type { RadioButtonChangeEvent } from "@volvo/vcdk/";
import { UITEXT, PRODUCT_TYPE_OPTIONS } from "../../../../constants/const";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import type { ConnectedProductInformationTabProps } from "../types";
import styles from "./ConnectedProductInformationTab.module.css";

const ConnectedProductInformationTab: React.FC<
    ConnectedProductInformationTabProps
> = ({
    formData,
    handleChoiceChange,
    handleTextChange,
    onBack,
    onNext,
    errors = {},
}) => {
    const [productToolTip, setProductToolTip] = useState<HTMLElement | null>(
        null
    );

    return (
        <div className={styles.Section}>
            <Typography variant="caption1">
                {UITEXT.ConnectedProductInformation.Notice}
            </Typography>
            <Divider />
            <div className={styles.ConnectedProductInformationContainer}>
                <Typography>
                    {UITEXT.ConnectedProductInformation.ChooseProductLabel}
                </Typography>
                {PRODUCT_TYPE_OPTIONS.map((opt, i) => (
                    <RadioButton
                        key={i}
                        error={opt.error}
                        label={opt.label}
                        value={opt.value}
                        name="productType"
                        size="small"
                        onChange={(e: RadioButtonChangeEvent) =>
                            handleChoiceChange(e.detail.value)
                        }
                        checked={formData.productType === opt.value}
                    />
                ))}
            </div>
            <Divider />
            <div className={styles.TextfieldWrapperSingle}>
                <div className={styles.TextfieldWrapper}>
                    <div>
                        <TextField
                            name={
                                formData.productType === "VIN"
                                    ? "productVIN"
                                    : "productChassisID"
                            }
                            label={
                                formData.productType === "VIN"
                                    ? "VIN"
                                    : "Chassis ID"
                            }
                            placeholder={`Enter ${formData.productType}`}
                            value={
                                formData.productType === "VIN"
                                    ? formData.productVIN
                                    : formData.productChassisID
                            }
                            onChange={handleTextChange}
                            size="medium"
                            className={styles.SmallContainerSectionField}
                            ref={(ref) => setProductToolTip(ref)}
                        />
                        <Tooltip
                            reference={productToolTip}
                            offset={20}
                            id="tooltip-1"
                            variant="default"
                        >
                            This information shall be provided to you by the
                            user
                        </Tooltip>
                    </div>
                    <div className={styles.ErrorWrapper}>
                        {errors &&
                            errors[
                                formData.productType === "VIN"
                                    ? "productVIN"
                                    : "productChassisID"
                            ] && (
                                <Typography
                                    variant="caption2"
                                    className={styles.ErrorMessage}
                                >
                                    {
                                        errors[
                                            formData.productType === "VIN"
                                                ? "productVIN"
                                                : "productChassisID"
                                        ]
                                    }
                                </Typography>
                            )}
                    </div>
                </div>
            </div>
            <Divider />
            <NavigationButtons onBack={onBack} onNext={onNext} />
        </div>
    );
};

export default ConnectedProductInformationTab;
